import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

const statusTemplate = (rowData) => {
  let tagClass = "custom-warning-tag";

  if (rowData.status === "Accepted") {
    tagClass = "custom-success-tag";
  } else if (rowData.status === "Rejected") {
    tagClass = "custom-danger-tag";
  }

  return <Tag value={rowData.status} className={tagClass} />;
};

const kioskTemplate = (rowData) => (
  <a
    href="#"
    style={{ color: "#047f94", textDecoration: "none", fontWeight: "800" }}
  >
    {rowData.kioskId}
  </a>
);

const columns = [
  { field: "dateTime", header: "Date/Time" },
  { field: "kioskId", header: "KIOSK ID", body: kioskTemplate },
  { field: "location", header: "Location" },
  { field: "type", header: "Type" },
  { field: "amount", header: "Amount (PKR)" },
  { field: "status", header: "Status", body: statusTemplate },
];

export default function RecentTransactionsTable({ loading, dashboardData }) {
  const kioskData = dashboardData?.recentTransactions || [];

  return (
    <div className="mt-3">
      <h3 className="text-xl font-bold text-lg">Recent Transactions</h3>

      <DataTable value={kioskData} scrollable rows={5} paginator>
        {columns.map((col, index) => (
          <Column
            key={index}
            field={col.field}
            header={col.header}
            body={col.body}
          />
        ))}
      </DataTable>
    </div>
  );
}
